/**
 * Allows you to add data-method="METHOD to links to automatically inject a form
 * with the method on click
 *
 * Example: <a href="{{route('customers.destroy', $customer->id)}}"
 * data-method="delete" name="delete_item">Delete</a>
 *
 * Injects a form with that's fired on click of the link with a DELETE request.
 * Good because you don't have to dirty your HTML with delete forms everywhere.
 */
function addDeleteForms() {
    $('[data-method]').append(function () {
            if (!$(this).find('form').length > 0) {
                return "\n<form action='" + $(this).attr('href') + "' method='POST' name='delete_item' style='display:none'>\n" +
                    "<input type='hidden' name='_method' value='" + $(this).attr('data-method') + "'>\n" +
                    "<input type='hidden' name='_token' value='" + $('meta[name="csrf-token"]').attr('content') + "'>\n" +
                    '</form>\n';
            } else {
                return ''
            }
        })
        .attr('href', '#')
        .attr('style', 'cursor:pointer;')
        .attr('onclick', '$(this).find("form").submit();');
}

/**
 * Place any jQuery/helper plugins in here.
 */
$(function () {
    /**
     * Add the data-method="delete" forms to all delete links
     */
    addDeleteForms();

    /**
     * Disable all submit buttons once clicked
     */
    $('form').submit(function () {
        $(this).find('input[type="submit"]').attr('disabled', true);
        $(this).find('button[type="submit"]').attr('disabled', true);
        return true;
    });

    let inputValueSave = "";

    /**
     * Generic confirm form delete using Sweet Alert
     */
    $('body').on('submit', 'form[name=delete_item]', function (e) {
        e.preventDefault();

        const form = this;
        const link = $('a[data-method="delete"]');
        const cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : 'Cancel';
        const confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : 'Yes, delete';
        const title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : 'Are you sure you want to delete this item?';

        Swal.fire({
            title: title,
            showCancelButton: true,
            confirmButtonText: confirm,
            cancelButtonText: cancel,
            type: 'warning'
        }).then((result) => {
            result.value && form.submit();
        });
    }).on('click', 'a[name=confirm_item]', function (e) {
        /**
         * Generic 'are you sure' confirm box
         */
        e.preventDefault();

        const link = $(this);
        const title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : 'Are you sure you want to do this?';
        const cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : 'Cancel';
        const confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : 'Continue';

        Swal.fire({
            title: title,
            showCancelButton: true,
            confirmButtonText: confirm,
            cancelButtonText: cancel,
            type: 'info'
        }).then((result) => {
            result.value && window.location.assign(link.attr('href'));
        });
    }).on('click', 'a[name=display_text]', function (e) {
        /**
         * Generic 'are you sure' confirm box
         */
        e.preventDefault();

        const link = $(this);
        const response = (link.attr('data-trans-response')) ? link.attr('data-trans-response') : '';

        Swal.fire({
            title: 'Odpowiedź na pytanie',
            html: response,
            showCancelButton: false,
            confirmButtonText: 'Zamknij okno',
            type: 'info'
        }).then((result) => {
            result.value && window.location.assign(link.attr('href'));
        });
    }).on('click', 'a[name=confirm_service_payment]', function (e) {
        /**
         * Generic 'are you sure' confirm box 
         */
        e.preventDefault();

        const link = $(this);
        const title = (link.attr('data-trans-title')) ? link.attr('data-trans-title') : '';
        const placeholder = (link.attr('data-trans-placeholder')) ? link.attr('data-trans-placeholder') : '';
        const maxchar = (link.attr('data-trans-max-char')) ? link.attr('data-trans-max-char') : 10000;
        const maxchar_text = (maxchar < 3000) ? '<br /><small>Max. znaków: ' + maxchar + '</small>' : '';
        const text = (link.attr('data-trans-text')) ? link.attr('data-trans-text') : 'Z Twojego konta zostanie pobrana kwota ';
        const money = (link.attr('data-trans-money')) ? link.attr('data-trans-money') : '';
        const doradca = (link.attr('data-trans-doradca')) ? link.attr('data-trans-doradca') : '';
        const cancel = (link.attr('data-trans-button-cancel')) ? link.attr('data-trans-button-cancel') : 'Anuluj';
        const confirm = (link.attr('data-trans-button-confirm')) ? link.attr('data-trans-button-confirm') : 'Potwierdzam';

        Swal.mixin({
            input: 'textarea',
            inputAttributes: {
                'maxlength': maxchar
            },
            confirmButtonText: 'Dalej &rarr;',
            showCancelButton: true,
            cancelButtonText: 'Anuluj',
            width: '42 rem',
            progressSteps: ['1', '2']
        }).queue([{
            html: 'Zamówienie usługi: <br /><strong>' + title + '</strong>' + maxchar_text,
            inputPlaceholder: placeholder,
            inputValue: (inputValueSave == "") ? "" : inputValueSave,
            text: 'Koszt usługi: ' + money
        }, {
            title: 'Potwierdzenie usługi',
            html: 'Potwierdzenie zamówienia usługi u Doradcy: <strong>' + doradca + "</strong><br />na kwotę: " + money,
            confirmButtonText: 'Zamawiam usługę',
            input: 'checkbox',
            inputPlaceholder: 'Akceptuję regulamin ezomagia.pl',
            inputValue: 0
        }]).then((result) => {
            inputValueSave = result.value[0];
            if ((result.value) && (result.value[1] == 1)) {
                link.parent().find("input[name='description_from_customer']").val(result.value[0]);
                link.parents('form').submit();
                /*const answers = JSON.stringify(result.value);
                Swal.fire({
                    title: 'All done!',
                    html: `Your answers:        <pre><code>${answers}</code></pre>      `,
                    confirmButtonText: 'Lovely!'
                })*/
            }
            if ((result.value) && (result.value[1] == 0)) {
                Swal.fire({
                    title: 'Prosimy o akceptację regulaminu',
                    icon: 'error',
                    confirmButtonText: 'OK'
                })
            }
        })
    });
    //marcin
    $('[data-toggle="tooltip"]').tooltip();
});
